<ng-content select="[campusListItemIcon], [ListItemIcon], list-item-icon, [list-item-icon]"></ng-content>
<div class="ui-list-item__container ui-list-item__container--center">
  <div class="ui-body-2">
    <ng-content select="[campusListItemTitle], [ListItemTitle], list-item-title, [list-item-title]"></ng-content>
  </div>
  <div class="ui-caption">
    <ng-content
      select="[campusListItemCaption], [ListItemCaption], list-item-caption, [list-item-caption]"
    ></ng-content>
  </div>
  <div>
    <ng-content select="[campusListItemActions], [ListItemActions], list-item-actions, [list-item-actions]">
    </ng-content>
  </div>
</div>

<div
  class="ui-list-item__container ui-list-item__container--right"
  [class.ui-list-item__content-right--separated]="contentRightSeparated"
>
  <ng-content select="list-item-content, [campusListItemContent], [ListItemContent], [list-item-content]"></ng-content>
</div>
